<template>
  <select-fi
    v-if="!isFite"
    class="fact-finder-facet-fi"
    :open="open"
    :name="name"
    :disabled="facet.disabled"
    :mobile-inline="isSliderFacet"
    large
    @toggle-open="toggleOpen"
    @close="$emit('close')"
    @change="(...params) => $emit('change', ...params)"
  >
    <template #selectionMobile>
      <template v-if="facet.type === 'TEXT'">
        <template v-for="element in facet.elements">
          <template v-if="element.selected">
            {{ element.text }}
          </template>
        </template>
      </template>
      <template v-else>
        <template v-for="element in facet.elements">
          <span
            v-if="element.selected"
            :key="element.name"
          >
            {{ element.selectedMinValue }} {{ facet.unit }} - {{ element.selectedMaxValue }}
            {{ facet.unit }}
          </span>
        </template>
      </template>
    </template>
    <fact-finder-text-facet
      v-if="facet.type === 'TEXT'"
      :facet="facet"
      @change="onChange"
      @close="onClose"
    />
    <fact-finder-slider-facet
      v-else-if="isSliderFacet"
      :group="facet"
      @change="onChange"
      @close="onClose"
    />
    <div v-else>{{ facet.name }} {{ facet.type }}</div>
  </select-fi>

  <div
    v-else
    class="fact-finder-facet-fi"
  >
    <div class="fact-finder-facet-fi__label">
      {{ name }}
    </div>
    <fact-finder-fite-checkbox-fi
      :facet="facet"
      @change="onChange"
    />
  </div>
</template>

<script>
import { SelectFi } from 'atoms';

import factFinderNgNameCleaner from '@/components/search-fact-finder-fi/factFinderNgNameCleaner';

import FactFinderFiteCheckboxFi from '../fact-finder-fite-checkbox-fi/FactFinderFiteCheckboxFi.vue';
import FactFinderSliderFacet from './fact-finder-slider-facet/FactFinderSliderFacet.vue';
import FactFinderTextFacet from './fact-finder-text-facet/FactFinderTextFacet.vue';

export default {
  name: 'FactFinderFacetFi',
  components: {
    FactFinderSliderFacet,
    FactFinderTextFacet,
    SelectFi,
    FactFinderFiteCheckboxFi,
  },
  props: {
    facet: {
      type: Object,
      required: true,
    },
    open: {
      type: Boolean,
    },
    idx: {
      type: Number,
      default: null,
    },
    registerDomElement: {
      type: Function,
      default: null,
    },
  },
  emits: ['change', 'close', 'toggle-open'],
  data() {
    return {
      wrapperStyle: {},
      internalOpen: false,
    };
  },
  computed: {
    isSliderFacet() {
      const {
        facet: { type },
      } = this;
      return ['FLOAT', 'INTEGER'].includes(type);
    },
    name() {
      return factFinderNgNameCleaner(this.facet.name);
    },
  },
  watch: {
    idx(newValue) {
      this.registerElement(newValue);
    },
  },
  mounted() {
    this.registerElement(this.idx);
  },
  methods: {
    registerElement(idx) {
      if (idx === 0 && this.registerDomElement) {
        this.registerDomElement(this.$el);
      }
    },
    onClose() {
      this.$emit('close');
    },
    toggleOpen() {
      this.$emit('toggle-open');
    },
    onChange(...params) {
      this.$emit('change', ...params);
    },
  },
};
</script>

<style src="./fact-finder-facet-fi-unscoped" />
